var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 11c0 1.66-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3 3 1.35 3 3Zm-8 0c0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.1-.37-2.11-.97-2.93l1.86-1.77 1.41 1.41c.39.39 1.02.39 1.41 0 .19-.2.29-.45.29-.71 0-.26-.1-.51-.29-.71l-1.37-1.37.6-.57 1.36 1.36c.39.39 1.02.39 1.41 0 .19-.2.29-.45.29-.71 0-.26-.1-.51-.29-.71l-1.32-1.32 1.31-1.24c.2-.2.3-.47.3-.73a.996.996 0 0 0-1.68-.73L7.54 6.72A4.91 4.91 0 0 0 5 6c-2.76 0-5 2.24-5 5Z",
    clipRule: "evenodd"
  })));
};
export default SvgKey;